module.exports = __webpack_public_path__ + "img/esoseska_homepage_2.30e87e55.png";